import BootstrapField from '../utility/BootstrapField';

export default class Attachment {
	constructor(data) {
		if (!data) {
			data = {};
		}

		if (data.comments == null) {
			data.comments = data.userFilename;
		}
		Object.assign(this, {
			id: data.id || null,
			userId: data.userId || null,
			uploadedDate: new BootstrapField({
				value: data.uploadedDate || null,
			}),
			comments: new BootstrapField({
				value: data.comments || null,
				required: true,
			}),
			filename: data.filename || null,
			subDirectory: data.subDirectory || null,
			userFilename: data.userFilename || null,
			sourceTable: data.sourceTable || null,
			sourceId: data.sourceId || null,
			fileType: data.fileType || null,
			fileSize: data.fileSize || null,
			width: data.width || null,
			height: data.height || null,
			fileUrl: data.fileUrl || null,
			thumbnailUrl: data.thumbnailUrl || null,
			downloadUrl: data.downloadUrl || null,
			firstName: data.firstName || null,
			lastName: data.lastName || null,
			organizationId: data.organizationId || null,
			organizationName: data.organizationName || null
		});
	}


	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getRawValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		return false;
	}
	revertChanges() {}
	saveChanges() {}
}